import { useRef } from "react";
import { DocHeader } from "@/components/DocHeader";
import { useApp } from "@/context/AppContext";
import { fmtDate } from "@/lib/format";
import { ReportActions } from "@/components/tpv/ZReport";

export default function TransferTicket({ move, actions = true }) {
  const { t, view, lang, money } = useApp();
  const ref = useRef(null);
  const isIn = move.kind === "in";
  return (
    <div className="space-y-3" data-testid="transfer-ticket-wrap">
      <div ref={ref} className="print-area font-mono-receipt text-sm p-4 bg-white rounded-xl border border-border" data-testid="transfer-ticket">
        <DocHeader center title={t("transfer_ticket")} sub={<><div dir="ltr">Nº {move.ticket_no || move.id.slice(0, 6).toUpperCase()}</div><div>{fmtDate(move.created_at, lang)}</div></>} />
        <div className="flex justify-between"><span>{t("from")}</span><span>{isIn ? (move.source === "shift_close" ? t("cash_register") : t("external")) : t("admin_vault")}</span></div>
        <div className="flex justify-between"><span>{t("to")}</span><span>{isIn ? t("admin_vault") : (move.note || t("external"))}</span></div>
        {move.shift_id && <div className="flex justify-between"><span>{t("shift")}</span><span dir="ltr">{move.shift_id.slice(0, 8)}</span></div>}
        <div className="flex justify-between"><span>{t("by")}</span><span>{move.staff_name}</span></div>
        {move.note && <div className="flex justify-between"><span>{t("hr_note")}</span><span className="text-end">{move.note}</span></div>}
        <div className="flex justify-between font-bold text-base border-t border-dashed border-foreground/40 mt-2 pt-2"><span>{t("amount")}</span><span dir="ltr" data-testid="transfer-amount">{money(move.amount)}</span></div>
        <div className="grid grid-cols-2 gap-6 mt-8 text-[10px] text-center">
          <div className="border-t border-foreground/60 pt-1">{t("delivered_by")}</div>
          <div className="border-t border-foreground/60 pt-1">{t("received_by")}</div>
        </div>
      </div>
      {actions && <ReportActions target={ref} name={`traspaso-${move.ticket_no || move.id.slice(0, 6)}`} printLabel={t("print_transfer")} />}
    </div>
  );
}
